module.exports = __webpack_public_path__ + "167f48565950b33986756fa02b686d4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/macha-panel-1080.jpg
// module id = 467
// module chunks = 0